const unified_login_base = 'https://home-qa.focusvision.com';
const unified_login_client_id = 'booking';
const host = 'uatbookings.focusvision.com';
const origin = `https://${host}`;
const confirmation_uri = `${unified_login_base}/login/confirmation`;

export const environment = {
  production: false,
  unified_login: `${unified_login_base}/login?response_type=code&client_id=${unified_login_client_id}&redirect_uri=${encodeURIComponent(origin)}%2Fauthorize&state=`,
  unified_signup: `${unified_login_base}/sign-up?client_id=${unified_login_client_id}&hostname=${host}&confirmation_uri=${encodeURIComponent(confirmation_uri)}&redirect_uri=${encodeURIComponent(origin)}%2Fauthorize`,
  api_url: 'https://uatbookings.focusvision.com/api/',
  recaptcha: {
    siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
  }
};
